/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * 数据中心
 * 解决全局数据共享问题
 */
var DB = function () {
    function DB() {
        (0, _classCallCheck3["default"])(this, DB);

        this.datas = {};
    }

    (0, _createClass3["default"])(DB, [{
        key: 'Set',
        value: function Set(key, value) {
            var _this = this;

            var expire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            var dataNode = { key: key, value: value, expire: expire };
            this.datas[key] = dataNode;
            if (expire > 0) {
                setTimeout(function () {
                    _scope.MsgBus.Pub('Data.Timeout.' + key, dataNode);
                    _this.Del(key);
                }, expire * 1000);
            }
            _scope.MsgBus.Pub('Data.Set.' + key, dataNode);
        }
    }, {
        key: 'Get',
        value: function Get(key) {
            var defaultVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            if (typeof this.datas[key] === 'undefined') {
                return defaultVal;
            }
            return this.datas[key]['value'];
        }
    }, {
        key: 'Del',
        value: function Del(key) {
            if (typeof this.datas[key] === 'undefined') {
                return;
            }
            _scope.MsgBus.Pub('Data.Del.' + key, this.datas[key]);
            delete this.datas[key];
            this.datas[key] = undefined;
        }
    }]);
    return DB;
}();

module.exports = new DB();



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/modules/DB.js
 ** module id = 125
 ** module chunks = 1
 **/